import { Link, styled } from '@mui/material';

const StyledLink = styled(Link)({
  cursor: 'pointer',
  fontWeight: 400,
  textDecoration: 'none',

  '&:hover': {
    textDecoration: 'none',
  },
});

export default StyledLink;
